import { FeedbackSuggestedPlanModel } from '../../../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';
import { PlanFeedbackServant } from '../../../../suggestions/components/plan_feedback/servants/plan_feedback_servant';
import { APUserModeConfig } from '../../user_mode_config/config/ap_user_mode_config';

export type IMarkAsMetUnmetUrl = () => string;

angular.module('capability-ng-academic-planner').factory(
  'markAsMetUnmetUrl',
  (
      ngAPUserModeConfig: APUserModeConfig,
      ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel
    ): IMarkAsMetUnmetUrl =>
    () => {
      const isEditMode = !PlanFeedbackServant.isPlanReadOnlyMode(ngFeedbackSuggestedPlanModel.read());
      const urlEnd = ngAPUserModeConfig.isAdvisor() && isEditMode ? 'suggested' : 'student';
      return `academicplan/${urlEnd}`;
    }
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/mark_as_met/stratgies/mark_as_met_unmet_url_strategy.ts